import type { IduraSettingsResponse, IduraSettingsUpdateRequest } from "@repo/shared/types";
import { get, patch } from "./_client";

const SETTINGS_BASE = "/internal/idura/settings";

export function getSettings(): Promise<IduraSettingsResponse> {
  return get<IduraSettingsResponse>(SETTINGS_BASE);
}

export function updateSettings(body: IduraSettingsUpdateRequest): Promise<IduraSettingsResponse> {
  return patch<IduraSettingsResponse>(SETTINGS_BASE, body satisfies IduraSettingsUpdateRequest);
}
